import { computed, ref } from 'vue'
import useApiRequest from '@/_core/hooks/useApiRequest'
import useEventEmitter from '@/_core/hooks/useEventEmitter'
import {
  getBasketData,
  addProductsToBasket,
  removeProductFromBasket,
  emptyBasket,
  applyPromocodeToBasket,
  getBasketPaymentLink
} from '../services/basket'
import Basket from '../models/Basket'
import { LS_BASKET_ID_KEY } from '../config'

export default function BasketController () {
  const { $emit, $on, $off } = useEventEmitter()

  const data = ref(null)
  const paymentLink = ref(null)

  // Получение корзины
  const basketRequest = useApiRequest(getBasketData)
  basketRequest.$on('success', () => {
    localStorage.setItem(LS_BASKET_ID_KEY, basketRequest.data.id)
    data.value = new Basket(basketRequest.data)
  })
  const requestBasket = async () => {
    await basketRequest.request(localStorage.getItem(LS_BASKET_ID_KEY) ?? null)
  }

  // Добавление товара
  const addProductsRequest = useApiRequest(addProductsToBasket)
  addProductsRequest.$on('success', () => {
    data.value = new Basket(addProductsRequest.data)
  })
  const addProducts = async (nomenklatures) => {
    return await addProductsRequest.request(data.value.id, nomenklatures)
  }

  // Удаление товара
  const removeProductRequest = useApiRequest(removeProductFromBasket)
  removeProductRequest.$on('success', () => {
    data.value = new Basket(removeProductRequest.data)
  })
  const removeProduct = async (nomenklatura) => {
    return await removeProductRequest.request(data.value.id, nomenklatura)
  }

  // Очистить корзину
  const emptyRequest = useApiRequest(emptyBasket)
  emptyRequest.$on('success', () => {
    data.value = new Basket(emptyRequest.data)
  })
  const clear = async () => {
    return await emptyRequest.request(data.value.id)
  }

  // Применить промокод
  const promocodeRequest = useApiRequest(applyPromocodeToBasket)
  promocodeRequest.$on('success', () => {
    data.value = new Basket(promocodeRequest.data)
  })
  const applyPromocode = async (promocode) => {
    return await promocodeRequest.request(data.value.id, promocode)
  }

  // Ссылка на оплату
  const paymentLinkRequest = useApiRequest(getBasketPaymentLink)
  paymentLinkRequest.$on('success', () => {
    paymentLink.value = paymentLinkRequest.data.payment_url
    $emit('getPaymentLink')
  })
  const getPaymentLink = async () => {
    return await paymentLinkRequest.request(data.value.id)
  }

  return {
    getPaymentLink,
    applyPromocode,
    clear,
    removeProduct,
    addProducts,
    requestBasket,
    data,
    paymentLink,
    isLoading: computed(() => basketRequest.isLoading || addProductsRequest.isLoading || removeProductRequest.isLoading || emptyRequest.isLoading || promocodeRequest.isLoading || paymentLinkRequest.isLoading),
    $on,
    $off
  }
}
